export default __webpack_public_path__ + "static/bg-pandas-profiling--mobile-b60a16bdba703195b2fe3f8263e08d4f.jpg";